import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import * as ProductUtils from '../../../utils/productHelpers';
import ProductDefaultImage from '../../../assets/images/product-default-image.jpg'
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { connect } from 'react-redux';
import * as Cart from '../../../utils/cartHelper';
import * as LocalStorage from '../../../utils/localStorageHelper';
// src/containers/commons/Hello.js
class ProductCard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      productPrice: '',}
    this.addressUpdated = this.addressUpdated.bind(this);
    this.getPriceOfProduct = this.getPriceOfProduct.bind(this);
  }
  componentDidMount() {

    let storedAddressValidation = Cart.getCartAttribute(Cart.ATTRIBUTE_DELIVERY_VALIDATION_STATUS);
    // console.log("storedAddressValidation",storedAddressValidation);
    this.getPriceOfProduct(storedAddressValidation&&storedAddressValidation.region=='SHIPPO');
    window.addEventListener('address_changed', this.addressUpdated);
  }
  componentWillUnmount() {
    window.removeEventListener('address_changed', this.addressUpdated);
  }
  addressUpdated(e) {
   

    let storedAddressValidation = Cart.getCartAttribute(Cart.ATTRIBUTE_DELIVERY_VALIDATION_STATUS);
    this.getPriceOfProduct(storedAddressValidation&&storedAddressValidation.region=='SHIPPO');
  }
  getPriceOfProduct(isOutside){
// console.log("getPriceOfProduct(isOutside)",isOutside);
    const { data} = this.props;
    if(isOutside){
      let outsideBoundaryPrice=data && data.Suggested ? data.Suggested.toFixed(2) : '';
      this.setState({productPrice:outsideBoundaryPrice})
    }else{

      let insideBoundaryPrice=data && data.PriceB ? data.PriceB.toFixed(2) : ''
      this.setState({productPrice:insideBoundaryPrice})
    }
  }

  render() {
    const { data, onSelectProduct, onAddToCart, noOutOfStock, checkAvailiblityAlert } = this.props;
  
    const productTitle = data && data.Description ? data.Description : '';
  const productImage = data && data.image ? data.image : null;
  const urlImage = productImage ? productImage.replace(/upload/, 'upload/w_250,h_280,c_fill')
    : null;
  const productPrice = this.state.productPrice;
  // console.log("productPrice",data);
  const productSize = data && data.Size ? data.Size : '';
  const isOutOfStock = !(data && data.Qty > 0);
  const isOnSale = data.OnSale ? true : false
  const salePrice = data.SalePrice;
  //currently cart is empty so use the set Delivery address
  let deliveryAddress = Cart.getCartAttribute(Cart.ATTRIBUTE_DELIVERY_ADDRESS);
  // console.log("1.deliveryAddress",deliveryAddress);
  const isDeliveryAddressSet=deliveryAddress?true:false;
  return (
    <div className="product-card">
      <div className="image-container" onClick={onSelectProduct ? onSelectProduct : null}>
        <div className="wrapper">
          <LazyLoadImage alt={productTitle} scrollPosition={50} src={urlImage ? urlImage : ProductDefaultImage} onError={(e) => {
            return e.target.src = ProductDefaultImage
          }}/>
        </div>
      </div>
      <div className={`info-container ${onAddToCart ? 'has-cart-button' : ''}`}>
        <div className="title" onClick={onSelectProduct ? onSelectProduct : null}>{productTitle}</div>
        <div className="subtitle">{productSize}</div>
        {isDeliveryAddressSet? (isOnSale ?
          <div className="sale-price-container">
            <div className="row">
              <div className="col-5">
                <span className="sale-label">WAS</span>
              </div>
              <div className="col-5">
              <span className="sale-label">NOW</span>
            </div>
            </div>
            <div className="row">
              <div className="col-5">
                <div className="sale-original-price-text" onClick={onSelectProduct ? onSelectProduct : null}><s>{productPrice ? `$${productPrice}` : ''}</s></div>
              </div>
              <div className="col-5">
                <div className="sale-price-text" onClick={onSelectProduct ? onSelectProduct : null}>{salePrice ? `$${salePrice}` : ''}</div>
              </div>

            </div>
          </div>
          :
          <div className="price-text" onClick={onSelectProduct ? onSelectProduct : null}>{productPrice ? `$${productPrice}` : ''}</div>):null
        }
        {isDeliveryAddressSet?(onAddToCart ? (
          <div className="add-to-cart-button" onClick={onAddToCart}>Add to Cart</div>
        ) : null):(<div className="add-to-cart-button" onClick={checkAvailiblityAlert}>Check Availbilty</div>)}
        
      </div>
      {isOutOfStock && !noOutOfStock ? (
        <div className="outofstock-tag">Out of Stock</div>
      ) : null}
    </div>
  )
  }
}

export default connect((state) => {
  return {
    cart: state.getIn(['cart', 'cart']),
  };
})(ProductCard);



// WEBPACK FOOTER //
// ./src/components/commons/cards/ProductCard.js